var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M10 15a5 5 0 1 0-4 2h12a5 5 0 1 0-4-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }